export function QuotesSVG({ className }: { className?: string }) {
  return (
    <svg
      width="72"
      height="64"
      viewBox="0 0 72 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Quotes">
        <g id="Vector">
          <path
            id="Vector 1"
            d="M0 51.7263L14.5187 12.2738H35.8522L27.5559 51.7263H0Z"
            fill="#DDE0EA"
          />
          <path
            id="Vector 2"
            d="M36.1484 51.7263L50.6671 12.2738H72.0007L63.7043 51.7263H36.1484Z"
            fill="#DDE0EA"
          />
        </g>
      </g>
    </svg>
  );
}
